import axios from '../../v2/app/services/axiosService';
import {isInteger, orderBy} from 'lodash';

export default {
  initForm() {
    return {
      accessControl: 'Groups', // MLD-2752
      source_template_id: null, // MLD-2097
      locale: 'en', // MLD-5385
      name: '',
      is_featured: false, // MLD-2846
      is_web: true,
      is_app: true,
      is_gmail: true,
      is_outlook: true,
      subject: '',
      subjects: [ // MLD-6517
        {
          id: null,
          position: 1,
          subject: '',
        },
      ],
      is_subject_editable: true, // MLD-2695
      editor: 'tinymce', // MLD-2473
      design: null, // MLD-2473
      html_head: '', // MLD-2620
      css: '', // MLD-2910
      html_body: '',
      preheader_text: '', // MLD-2892
      shared_link_url_parameters: null, // MLD-2954
      text_body: '',
      sms_body: '',
      status: 'Active',
      is_editable: true,
      is_quick_share: false, // MLD-2757
      is_default: false,
      is_campaign: true, // MLD-2524
      personal_message_allowed: false, // MLD-3998
      personal_message_required: false, // MLD-3998
      can_be_copied: true, // MLD-2097
      can_be_selected: true, // MLD-4653
      can_share_links: true, // MLD-2695
      attachment_url: null, // MLD-3420
      attach_file: false,
      sanitize_attachment_name: true, // MLD-1609
      presentations: [],
      // MLD-2325
      user_id: '',
      asset_id: null,
      release_at: null,
      expires_at: null,
      folder_id: '', // MLD-2327
      brand_id: '', // MLD-4796
      smart_email_bcc_enabled: true, // MLD-2476
      bcc_recipients: null, // MLD-5567
      cc_recipients: null, // MLD-5566
      groups: [], // MLD-2482
      instructions: null, // MLD-303
    };
  },
  async getRecentlyUsedTemplatesForCurrentUser() { // MLD-6403
    const response = await axios.get(`/api/share-templates/user/recent`);
    return response.data;
  },
  async getTemplatesForUser(params = {}) { // MLD-2290
    const response = await axios.get('/api/share-templates/user', {params});
    return orderBy(response.data, ['is_default', 'is_featured', 'slug'], ['desc', 'desc', 'asc']);
  },
  async getQuickShareTemplates() { // MLD-3277
    const options = {
      params: {
        is_quick_share: true,
      }
    }
    const response = await axios.get(`/api/share-templates`, options);
    return response.data;
  },
  async getAllTemplates() {
    const response = await axios.get(`/api/share-templates?show_all=1`);
    return orderBy(response.data, ['status', 'slug'], ['asc', 'asc']);
  },
  async render(templateID, form) {
    const response = await axios.post(`/api/share-templates/${templateID}/render`, form);
    return response.data;
  },
  async getImages(templateID) { // MLD-7818
    const response = await axios.get(`/api/share-templates/${templateID}/images`);
    return response.data;
  },
  async getTemplate(templateID, userID = null) {
    const params = { // MLD-2823
      sender_id: userID,
    }
    const response = await axios.get(`/api/share-templates/${templateID}`, {params});
    return response.data;
  },
  async getLinks(templateID, form = {}) {
    const params = form
    const response = await axios.get(`/api/share-templates/${templateID}/links`, {params});
    return response.data;
  },
  async getWebhookMetrics(templateID, senderID = null) { // MLD-2534
    const params = {
      sender_id: senderID,
    }
    const response = await axios.get(`/api/share-templates/${templateID}/webhook-metrics`, {params});
    return response.data;
  },
  async create(form) {
    const response = await axios.post(`/api/share-templates`, form);
    return response.data;
  },
  async update(templateID, form) {
    const response = await axios.put(`/api/share-templates/${templateID}`, form);
    return response.data;
  },
  async updateDesign(templateID, form) { // MLD-2473
    const response = await axios.put(`/api/share-templates/${templateID}/design`, form);
    return response.data;
  },
  async destroy(templateID) {
    const response = await axios.delete(`/api/share-templates/${templateID}`);
    return response.data;
  },
  async renderText(input, data = {}) { // MLD-2726
    const form = {
      input: input,
      ...data,
    }
    const response = await axios.post(`/api/share-templates/render`, form);
    return response.data;
  },
  async copyToTeam(form, templateID) { // MLD-3800
    const response = await form.post(`/api/share-templates/${templateID}/copy-to-team`);
    return response.data;
  },
  async exportLinks(templateID) { // MLD-5145
    const config = {
      params: {
        export: true,
      }
    }
    const filename = `template_${templateID}_links.csv`;
    const response = await axios.get(`/api/share-templates/${templateID}/links`, config);
    const data = response.data;
    // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
    const blob = new Blob([data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    return data;
  },
  /**
   * Download the Unlayer design JSON
   * @param {Object} template
   * @param {Array} design
   * @param {String} filename
   * @returns {Promise<void>}
   */
  async downloadJSON(template, design, filename) {
    const data = JSON.stringify(design, null, 4);
    let blob = new Blob([data], {type: 'application/json'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${filename}.json`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  /**
   * MLD-7684
   * @param html
   * @param filename
   * @returns {Promise<void>}
   */
  async downloadHTML(html, filename) {
    let blob = new Blob([html], {type: 'text/html'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${filename}.html`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  /**
   * MLD-7683
   * @param {Object} template
   * @param {Object} form
   * @returns {Promise<Boolean>}
   */
  async downloadPDF(template, form) {
    try {
      const config = {
        responseType: 'blob',
      }
      const {data: pdf} = await axios.post(`/api/share-templates/${template.id}/convert/pdf`, form, config)
      let blob = new Blob([pdf], {type: 'application/pdf'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `MobileLocker-EmailTemplate-${template.id}_${Date.now()}.pdf`;
      link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
      return true;
    } catch (e) {
      alert(`There was an error downloading the PDF. Please contact Mobile Locker support and provide the template ID and error message: ${e.message}`)
    }
  },
  async getCustomTagsForTemplate(templateID) { // MLD-6454
    const config = {
      params: {
        template_id: templateID,
      }
    };
    const response = await axios.get(`/api/share-template-custom-tags`, config);
    return response.data;
  },
  getCustomTagTypes() {
    return [
      {id: 'List', text: 'List', disabled: false,},
      {id: 'HTML', text: 'HTML List', disabled: false,},
      {id: 'Date', text: 'Date Picker', disabled: false,}, // MLD-7076
      {id: 'Time', text: 'Time Picker', disabled: false,}, // MLD-7076
      {id: 'Text', text: 'Free Text', disabled: false,}, // MLD-7348
      {id: 'CRM Query', text: 'CRM Query', disabled: false,}, // MLD-7075
    ]
  },
  /**
   * @param {number} templateID
   * @param {object} customTag
   * @returns object
   */
  initCustomTagForm(templateID, customTag) {
    return {
      template_id: isInteger(templateID) ? templateID : '',
      name: customTag?.name ?? null,
      instructions: customTag?.instructions ?? null,
      is_required: customTag?.is_required ?? true,
      options: customTag?.options ?? [],
      tag_type: customTag?.tag_type ?? null,
      // MLD-7076
      settings: {
        crm_query: customTag?.settings?.crm_query ?? null, // MLD-7075
        date_format: 'F j, Y',
        date_min: 'today',
        time_format: 'g:i A',
        time_step: '30', // Minutes between times
        time_start: '06:00',
        time_end: '22:00',
      },
    }
  },
  getDateFormats() { // MLD-7076
    return [
      {
        value: 'F j, Y',
        text: 'Month Day, Year (e.g., December 15, 2024)',
      },
      {
        value: 'Y-m-d',
        text: 'Year-Month-Day (e.g., 2024-12-15)',
      },
      {
        value: 'm/d/Y',
        text: 'Month/Day/Year (e.g., 12/15/2024)',
      },
    ]
  },
  getTimeFormats() { // MLD-7076
    return [
      {
        value: 'g:i A',
        text: '12-hour clock with minutes and AM/PM (e.g., 1:30 PM)',
      },
      {
        value: 'g:i a',
        text: '12-hour clock with minutes and am/pm (e.g., 1:30 pm)',
      },
    ]
  },
  /**
   * @param {object} form
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async createCustomTag(form) {
    const response = await axios.post(`/api/share-template-custom-tags`, form);
    return response.data;
  },
  /**
   * @param {number} customTagID
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async getCustomTag(customTagID) {
    const response = await axios.get(`/api/share-template-custom-tags/${customTagID}`);
    return response.data;
  },
  /**
   * @param {number} customTagID
   * @param {Form} form
   * @returns {*}
   */
  async updateCustomTag(customTagID, form) {
    const response = await form.patch(`/api/share-template-custom-tags/${customTagID}`);
    return response.data;
  },
  /**
   * @param {number} customTagID - The ID of the custom tag to delete.
   * @returns {Promise<Array>} - A promise that resolves to the response data.
   */
  async deleteCustomTag(customTagID) {
    const response = await axios.delete(`/api/share-template-custom-tags/${customTagID}`);
    return response.data;
  },
  async getSubjectLinesFor(templateID) { // MLD-6517
    try {
      const response = await axios.get(`/api/share-templates/${templateID}/subject-lines`);
      return response.data;
    } catch (err) {
      return [];
    }
  },
  async suggestSubjectLine(subject) { // MLD-6527
    const data = {
      subject,
    };
    const response = await axios.post(`/api/share-template-subject-lines/suggest`, data);
    return response.data;
  }
}
